import api from "./axios";

export const getAdminUsers = async (params = {}) => {

  try {

    const query = {};

    if (params.page) query.page = params.page;
    if (params.limit) query.limit = params.limit;

    if (params.search) query.search = params.search;

    if (params.status) query.status = params.status;

    if (params.roleName) query["role.name"] = params.roleName;

    if (params.planName) query["plan.name"] = params.planName;

    if (params.subscriptionStatus)
      query["subscription.status"] = params.subscriptionStatus;

    if (params.sortBy) query.sortBy = params.sortBy;

    if (params.sortOrder) query.sortOrder = params.sortOrder;

    const response = await api.get("/user/admin/list", {
      params: query
    });

    return {
      data: response.response.data,
      pagination: response.response.pagination
    };

  } catch (error) {

    console.error("Error fetching admin users:", error);

    return {
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    };

  }

};

export const suspendUser = async (userId) => {
  try {
    const response = await api.patch(`/user/admin/suspend/${userId}`);
    return response.response;
    } catch (error) {
    console.error(`Error suspending user ${userId}:`, error);
    throw error;
  }
};

export const restoreUser = async (userId) => {
    try {
        const response = await api.patch(`/user/admin/restore/${userId}`);
        return response.response;
    } catch (error) {
        console.error(`Error restoring user ${userId}:`, error);
        throw error;
    }
};